import { Box, Checkbox, Heading, Text } from 'native-base'
import { FormikProps } from 'formik'

import { colors } from '../../utils/theme/configureTheme'
import { SupportFeedbackFormValues } from './types'

interface ConsentSectionProps {
  formikProps: FormikProps<SupportFeedbackFormValues>
}

/** Support feedback form section for capturing follow-up consent. */
export default function ConsentSection({ formikProps }: ConsentSectionProps) {
  const { values, setFieldValue } = formikProps

  return (
    <Box px={4} pb={6}>
      <Heading fontSize={18} fontWeight="600" fontFamily="bodySemiBold" color={colors.brand.softBlack} mb={3}>
        Contact Information
      </Heading>
      <Checkbox
        isChecked={values.consentToFollowUp}
        onChange={isSelected => setFieldValue('consentToFollowUp', isSelected)}
        value="consentToFollowUp"
        accessibilityLabel="consent to follow-up"
        borderRadius={4}
        borderWidth={2}
        borderColor={colors.brand.softBlack}
        backgroundColor={colors.brand.transparent}
        _icon={{
          size: 3,
          color: colors.brand.softBlack,
        }}
        _checked={{
          borderWidth: 2,
          borderColor: colors.brand.softBlack,
          backgroundColor: colors.brand.transparent,
        }}
        display="flex"
        alignItems="center"
      >
        <Text fontSize={14} fontWeight={400} lineHeight="125%" color={colors.brand.softBlack}>
          I am okay with Veho contacting me for additional follow-up or feedback.
        </Text>
      </Checkbox>
    </Box>
  )
}
